// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'tiemposFine', 'tiemposFine Fallback'"},"className":"__className_940086","variable":"__variable_940086"};